import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Sesja = wyłącznie ciasteczko httpOnly (niedostępne dla JS, więc XSS nie wykradnie tokenu).
// X-Requested-With jest wymagany przez backend dla żądań zmieniających dane (ochrona CSRF).
const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "FiberPass" } });

// Znacznik "jestem zalogowany" (NIE jest poświadczeniem) — tylko do logiki UI/przekierowań.
export const SESSION_FLAG = "fp_session";
export const hasSession = () => { try { return localStorage.getItem(SESSION_FLAG) === "1"; } catch { return false; } };
export const setSession = (on) => {
  try {
    if (on) localStorage.setItem(SESSION_FLAG, "1"); else localStorage.removeItem(SESSION_FLAG);
    localStorage.removeItem("fp_token"); // sprzątanie po starszych wersjach
  } catch { /* ignore */ }
};

// Konto dezaktywowane/token nieważny w trakcie sesji → natychmiastowe wylogowanie
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    if (status === 401 && hasSession() && !url.includes("/auth/login")) {
      setSession(false);
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/";
    }
    if (status === 423 && !url.includes("/activation/")) {
      // License became invalid mid-session (e.g. clock rolled back) → show activation.
      const last = Number(sessionStorage.getItem("fp_lock_reload") || 0);
      if (Date.now() - last > 5000) {
        sessionStorage.setItem("fp_lock_reload", String(Date.now()));
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Wystąpił błąd. Spróbuj ponownie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Krótkotrwały token wyłącznie do linków ?auth= (pliki, PDF, strumienie) — token sesji nie trafia do URL-i/logów.
const DL_KEY = "fp_dl";
let dlTimer = null;

export function dlToken() {
  try {
    const v = JSON.parse(sessionStorage.getItem(DL_KEY) || "null");
    return v && v.exp > Date.now() ? v.token : "";
  } catch { return ""; }
}

export async function refreshDlToken() {
  if (!hasSession()) return "";
  try {
    const { data } = await api.post("/auth/download-token");
    sessionStorage.setItem(DL_KEY, JSON.stringify({ token: data.token, exp: Date.now() + (data.expires_in - 60) * 1000 }));
    return data.token;
  } catch { return ""; }
}

export function startDlTokenRefresh() {
  if (dlTimer) clearInterval(dlTimer);
  dlTimer = setInterval(refreshDlToken, 5 * 60 * 1000);
  return refreshDlToken();
}

export function stopDlTokenRefresh() {
  if (dlTimer) clearInterval(dlTimer);
  dlTimer = null;
  sessionStorage.removeItem(DL_KEY);
}

// Otwiera pobieranie w nowej karcie ze świeżym tokenem pobierania.
export async function openDownload(path) {
  const tk = (await refreshDlToken()) || dlToken();
  const sep = path.includes("?") ? "&" : "?";
  window.open(`${API}${path.startsWith("/") ? "" : "/"}${path}${sep}auth=${encodeURIComponent(tk)}`, "_blank");
}

export default api;
